
import * as React from "react";
import User from "../../_data/models/User";
import {Link} from "react-router-dom";
import {UsersRoutes} from "../../routes";
import ReduxInfiniteScroll from 'redux-infinite-scroll';
import Meta from "../../_data/models/Meta";

interface Props {
    items: User[];
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
}

interface ListItemProps {
    item: User
}

export const ShopProfessionalListItemComponent = (props: ListItemProps) => {
    const {item} = props;

    return (
        <li>
            <div className="media-object">
                <div className="media-object-section flushed middle">
                    <div className="img-wrapper small circle">
                        <img src={item.profilePicture()} />
                    </div>
                </div>
                <div className="media-object-section middle">
                    <div className="text-group">
                        <p><b>{item.username()}</b></p>
                        <small className="subheader">{item.profession}</small>
                    </div>
                </div>
            </div>
            <Link to={UsersRoutes.show(item.id)} className="button primary pull-right">
                <i className="fa fa-eye-o"></i>&nbsp; View Professional
            </Link>
        </li>
    );
};

export const ShopProfessionalsComponent = (props: Props) => {


    const {items, loading, loadMore, meta} = props;

    return (
        <ReduxInfiniteScroll
            holderType="ul"
            className="list-block flex-container"
            loadMore={() => loadMore(meta)}
            elementIsScrollable={false}
            loadingMore={loading}
            showLoader={false}
            threshold={200}>
            {
                items.map((each: User) => {
                    return <ShopProfessionalListItemComponent  key={"user_"+each.id} item={each}/>;
                })
            }
        </ReduxInfiniteScroll>
    );
};


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopProfessionalsComponent.tsx